import { render, staticRenderFns } from "./ClassMaterial.vue?vue&type=template&id=4ad5fb26&scoped=true&"
import script from "./ClassMaterial.vue?vue&type=script&lang=js&"
export * from "./ClassMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5fb26",
  null
  
)

export default component.exports